export const state = {
  unreadAnnouncement: 0,
}

export const mutations = {
  INCREMENT_UNREAD_ANNOUNCEMENT(state) {
    state.unreadAnnouncement++
  },
  DECREMENT_UNREAD_ANNOUNCEMENT(state) {
    state.unreadAnnouncement--
    if (state.unreadAnnouncement < 0) {
      state.unreadAnnouncement = 0
    }
  },
  RESET_UNREAD_ANNOUNCEMENT(state) {
    state.unreadAnnouncement = 0
  },
  SET_UNREAD_ANNOUNCEMENT(state, newValue) {
    state.unreadAnnouncement = newValue
  },
}

export const actions = {
  incrementUnreadAnnouncement({ commit }) {
    commit('INCREMENT_UNREAD_ANNOUNCEMENT')
  },
  decrementUnreadAnnouncement({ commit }) {
    commit('DECREMENT_UNREAD_ANNOUNCEMENT')
  },
  resetUnreadAnnouncement({ commit }) {
    commit('RESET_UNREAD_ANNOUNCEMENT')
  },
  setInitialUnreadAnnouncement({ commit }, initialValue) {
    commit('SET_UNREAD_ANNOUNCEMENT', initialValue)
  },
}
